import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getDeviceByVin } from './helpers/get-device-by-vin';
import { normalizeVinForServiceCall } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getDeviceIdByVin(
    { vin }: { vin: string },
    dependencies: DependenciesPayload,
) {
    try {
        const { deviceId } = await getDeviceByVin(
            { vin: normalizeVinForServiceCall(vin) },
            dependencies,
        );
        return deviceId;
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
